// Utils bundle entry point. Combines the non-React helper modules into a single
// IIFE (loaded globally via _Layout) and exposes each under its original global
// name so the existing Razor call-sites (Utils.*, SchemeDetails.updateSchemeDetails)
// keep working unchanged.
import * as Utils from "./Utils";
import * as SchemeDetails from "./SchemeDetails";

declare global {
    interface Window {
        Utils: typeof Utils;
        SchemeDetails: typeof SchemeDetails;
    }
}

window.Utils = Utils;
window.SchemeDetails = SchemeDetails;
